import { classifyMediaUrl, extractUrlsFromText } from './classify-url.js';
import type { MessageAttachment } from './types.js';
import { parseVideoEmbedUrl } from './video-embed.js';

/** Pre-build attachment for sole outbound URL so bubble shape does not change after confirm/WS. */
export function buildOptimisticAttachmentFromText(
  text: string,
): MessageAttachment | undefined {
  const trimmed = text.trim();
  const urls = extractUrlsFromText(trimmed);
  if (urls.length !== 1 || urls[0] !== trimmed) return undefined;

  const kind = classifyMediaUrl(urls[0]);
  if (kind !== 'video_embed') return undefined;

  const embed = parseVideoEmbedUrl(urls[0]);
  if (!embed) return undefined;

  return {
    kind: 'video_embed',
    url: embed.watchUrl,
    embedUrl: embed.embedUrl,
    provider: embed.provider,
  };
}

export function optimisticTextForOutgoingSend(
  text: string,
  attachment?: MessageAttachment,
): string {
  if (attachment?.kind === 'video_embed') return '';
  return text;
}
